import React, { useEffect } from "react"
import ReactWebcam from "react-webcam"
import { decodeQrFromImageSrc } from "../../utils/qrcode"
import { WebcamContainer } from "./styled"

interface IWebcamProps {
  onQrDetected: (qrData: string) => void,
}

export const Webcam = ({ onQrDetected }: IWebcamProps) => {
  const webcamRef = React.useRef<ReactWebcam>(null)

  useEffect(() => {
    let stopped = false
    let timeoutId: ReturnType<typeof setTimeout> | undefined

    const scan = async () => {
      if (stopped) return

      const imageSrc = webcamRef.current?.getScreenshot()
      if (imageSrc) {
        const qrData = await decodeQrFromImageSrc(imageSrc)
        if (stopped) return

        if (qrData) {
          onQrDetected?.(qrData)
          return
        }
      }

      timeoutId = setTimeout(scan, 2000)
    }

    scan()

    return () => {
      stopped = true
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId)
      }
    }
  }, [onQrDetected])

  return (
    <WebcamContainer>
      <ReactWebcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        screenshotQuality={1}
        videoConstraints={{
          facingMode: "environment",
        }}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </WebcamContainer>
  )
}
